export default "__VITE_ASSET__40a50fd8__"